import { create } from 'zustand';
export const useAuthStore = create(set => ({
    setAuthProfile: (action) => {
        set(prevState => typeof action === 'function' ? action(prevState) : action);
    },
}));
